import type { Monitoring } from 'commonTypes/api/monitoring';
import { HEADER_NAMES } from 'constants/headersNames';
import { BFF_PROXY_API } from 'constants/routes';

import { axiosWithoutRetries } from 'shared/api/requestInstance';
import { getOrCreateDeviceId } from 'shared/lib/getOrCreateDeviceId';

/**
 * Отправляет событие/ошибку в сервис мониторинга.
 * Fire-and-forget: не влияет на пользовательский флоу.
 * Обязательные для API поля (service/userId/traceId/channel) докидывает BFF.
 */
export const sendMonitoringEvent = (params: Monitoring.TEventClientRequest): void => {
  if (typeof window === 'undefined') {
    return;
  }

  const resolvedSessionId = params.sessionId || getOrCreateDeviceId();

  const body: Monitoring.TEventClientRequest = {
    ...params,
    sessionId: resolvedSessionId,
  };

  axiosWithoutRetries
    .post<Monitoring.TEventResponse>(BFF_PROXY_API.sendMonitoringEvent, body, {
      headers: {
        [HEADER_NAMES.sessionId]: resolvedSessionId,
      },
    })
    .catch(() => undefined);
};
